import gql from "graphql-tag"

export const AllPricingTemplates = gql`
  query AllPricingTemplates($first: Int, $cursor: String, $orderBy: [String], $searchTerm: String, $filters: [FilterInput]) {
    allPricingTemplates(first: $first, after: $cursor, orderBy: $orderBy, searchTerm: $searchTerm, filters: $filters) {
      edges {
        cursor
        node {
          id
          pk
          visibleToCustomers
          carModel {
            id
            name
            make
            series
            groupType{
              id
              name
            }
          }
          price
          minimumPrice
          maximumPrice
          carYearMax
          carYearMin
          carMileageMin
          carMileageMax
          carMileageMinInKm
          carMileageMaxInKm
          intervalUnit
          interval
          isActive
          currency { code symbol }
          isDefault
          carColor
          branch {
            id
            name
            defaultMileageUnit
          }
          agreementType {
            id
            name
            branch {
              id
              defaultMileageUnit
            }
          }
          title
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        length
      }
    }
  }
`

export const AllAgreementTypes = gql`{
    allAgreementTypes(isActive: true) {
      edges {
        node {
          id
          name
          isActive
          branch {
            id
            name
            defaultMileageUnit
          }
        }
      }
    }
  }
`

export const AllCarModels = gql`
  {
    allCarModels(orderBy: ["-make"]){
      edges {
        node {
          id
          name
          make
          series
          groupType{
            id
            name
          }
        }
      }
    }
  }
`

export const AllCarModelGroupTypes = gql`
  {
    allCarModelGroupTypes{
      edges {
        node {
          id
          name
        }
      }
    }
  }
`

export const AllPromotionsTemplates = gql`
  query AllPromotionsTemplates($first: Int, $cursor: String, $orderBy: [String], $searchTerm: String, $filters: [FilterInput]) {
    allPromotionsTemplates(first: $first, after: $cursor, orderBy: $orderBy, searchTerm: $searchTerm, filters: $filters) {
      edges {
        cursor
        node {
          id
          pk
          visibleToCustomers
          isPercentage
          carModel {
            id
            name
            make
            series
            groupType{
              id
              name
            }
          }
          interval
          intervalUnit
          promoPrice
          minimumPromoPrice
          maximumPromoPrice
          carYearMax
          carYearMin
          cycle
          minCycle
          maxCycle
          isActive
          currency { code symbol }
          startDate
          expirationDate
          agreementType {
            id
            name
          }
          title
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`
